import ModalSlot, { slot } from "src/109323/components/ModalSlot"

const image = "https://assets.swoogo.com/uploads/full/3019927-651f1c4c0edc6.png"

const links = [
    {
        width: "57.8%",
        height: "8.6%",
        top: "10.3%",
        left: "21.3%"
    },
    ...slot(11, {
        space: 25.5 - 19.3, 
        width: 57.8,
        height: 5.6,
        init: 19.3,
        left: 21.3
    }),
    {
        width: "28.8%",
        height: "4.6%",
        top: "89.3%",
        left: "33.3%"
    }
]

const slots = [
    {
        label: "The Business Leader's guide to culture and innovation: Ellie Pavlick - Balancing the Risk and Reward of AI; Sean Campbell - Effective Communication; Ganesh Krishnan - Engaging the Workforce for Holistic Security",
        href: "https://www.securityforum.org/spotlight-on/the-business-leaders-guide-to-culture-and-innovation/"
    },
    {
        label: "The future of international relations: Ideologies clash in the hyperconnected world",
        href: "https://www.securityforum.org/spotlight-on/threat%20horizon-2025-the-future-of-international-relations-ideologies-clash-in-the-hyperconnected-world/"
    },
    {
        label: "Achieving cyber resilience through influence",
        href: "https://www.securityforum.org/spotlight-on/achieving-resilience-through-influence/"
    },
    {
        label: "Taking an ecosystem approach to cyber resilience",
        href: "https://www.securityforum.org/spotlight-on/taking-an-ecosystem-approach-to-cyber-resilience/"
    },
    {
        label: "The Future of Data: Regulation plays catch up with value",
        href: "https://www.securityforum.org/spotlight-on/threat-horizon-2025-the-future-of-data-regulation-plays-catch-up-with-value/"
    },
    {
        label: "Managing human behaviour to keep pace with digital acceleration",
        href: "https://www.securityforum.org/spotlight-on/managing-human-behaviour-to-keep-pace-with-digital-acceleration/"
    },
    {
        label: "What they don't teach in CISO school",
        href: "https://www.isflive.org/s/community-webcast/a2E6M000001gNUOUA2/what-they-dont-teach-in-ciso-school"
    },
    {
        label: "What ChatGPT did next",
        href: "https://www.isflive.org/s/community-webcast/a2E6M000001gV0rUAE/what-chatgpt-did-next"
    },
    {
        label: "When infosec gets personal",
        href: "https://www.isflive.org/s/community-webcast/a2E6M000001xANgUAM/when-infosec-gets-personal"
    },
    {
        label: "How Copenhagen is tackling the cyber skills shortage",
        href: "https://www.isflive.org/s/community-webcast/a2E6M000001gFNmUAM/how-copenhagen-is-tackling-the-cyber-skills-shortage"
    },
    {
        label: "How history and language influence Infosec",
        href: "https://www.isflive.org/s/community-webcast/a2E6M000002f869UAA/how-history-and-language-influence-infosec"
    },
    {
        label: "Exploring Careers: Security testing",
        href: "https://www.isflive.org/s/community-webcast/a2E6M000002f1n3UAA/exploring-careers-security-testing"
    },
    {
        href: "https://www.isflive.org/s/isf-videos-podcasts",
        label: "visit our media library on ISF Live"
    }
]

export default () => <ModalSlot img={image} links={links} slots={slots} />